import { useCallback, useEffect, useState } from "react";
import { genericGet } from "services/services.general";

const useMunicipalities = (provinceId = null) => {
  const [municipalities, setMunicipalities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const refetch = useCallback(() => {
    setIsLoading(true);

    genericGet({
      url: "/municipality",
      params: provinceId != null ? { provinceId } : null,
      callback: (data) => {
        setMunicipalities(data);
        setIsLoading(false);
      },
    });
  }, [provinceId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data: municipalities, isLoading, refetch };
};

export default useMunicipalities;
